import React, { useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import FormAdmissionClassXI from "../Component/FormAdmissionClassXI";
import { Link } from "react-router-dom";
const StudentInfo = () => {
  const [showFormXI, setShowFormXI] = useState(false);
  const handleOpenFormXI = () => setShowFormXI(true);
  const handleCloseFormXI = () => setShowFormXI(false);
  return (
    <>
      <Header />
      {showFormXI && <FormAdmissionClassXI onClose={handleCloseFormXI} />}
      <Breadcrumb
        title="  Student Admission"
        tabName="  Student Admission"
      />
      <div className="innerPage">
        <div className="container">
          <div className="row g-3">
            <div className="col-12">
              <Link to='/admission-procedure'>
                <button className="handleOpenFormXI" >
                  Admission Procedure
                </button>
              </Link>
            </div>
            <div className="col-xl-6">
              <img src="https://webapi.entab.info/api/image/NCSR/public/Images/admission_procedure.jpeg" style={{ height: "700px", margin: "auto", display: "block" }} />
            </div>

            <div className="col-xl-6">
              <div className="class-list">
                <ul>
                  <li><Link to="/admission-procedure" className="class-link">LKG</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">UKG</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 1</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 2</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 3</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 4</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 5</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 6</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 7</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 8</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 9</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 10</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 11</Link></li>
                  <li><Link to="/admission-procedure" className="class-link">Class 12</Link></li>
                </ul>
              </div>
            </div>





          </div>
          {/* <div className="col-md-8">
              <h3>
                Admission to <span>Holy Spirit Pre-Primary School</span>
              </h3>
              <ul className="list-view">
                <li>
                  
                  Admission to this School is restricted by condition of age,
                  ability and conduct. Applicants for admission will be
                  carefully selected.
                </li>
                <li>
                  
                  The age criteria for Nursery Class is between 3 to 4
                  years.
                </li>
                <li>
                  For all the admissions to kindergarten classes ORIGINAL birth
                  certificate with a photostat copy of Birth Certificate duly
                  attested should be produced in the office. (Original birth
                  certificate is returned to the parents after verification of
                  the documents). At the time of admission, the students should
                  be introduced personally by their parents/guardian who will be
                  responsible for their studies, fees, conduct and
                  discipline.
                </li>
                <li>
                  The Principal/Head Mistress reserves to herself the right of
                  admission.
                </li>
                <li>
                  For more information on admission kindly contact the school
                  office.
                </li>
              </ul>

              <h3>NURSERY FORMS for Session 2026-2027</h3>
              <p>
                NURSERY CLASS Registration form will be available ONLINE on
                School website and on below mentioned campuscare10x link.
              </p>
              <p>
                <b>ONLINE REGISTRATION FORM will be available from:</b>
              </p>

              <p>
                <b>
                  01st December 2025 at 10 am till 5th December 2025 upto 11 pm.
                </b>
              </p>
              <p>
                <b>
                  The link for registration form will be available at:
                  <a href="https://entab.online/ncsraj" target="_blank">
                    https://entab.online/ncsraj
                  </a>
                </b>
              </p>
              <p>
                <b>
                  (Note : The link will be available at above url from 01st
                  December 2025 at 10 am)
                </b>
              </p>

              <p>
                <b>Eligibility:</b> The age of the child seeking admission to
                Nursery Class 2026-27 should be between 3 years and 4 years as
                on 01 June, 2026. If your child is NOT within the age limit
                specified, she will not be eligible for admission.
              </p>
            </div>
            <div className="col-md-4">
              <p>Procedure to fill the online registration form: -</p>
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/NCSR/public/Images/admission-registration.png"
              >
                <LazyLoad>
                  
                  <img
                    src="https://webapi.entab.info/api/image/NCSR/public/Images/admission-registration.png"
                    class="img-fluid admissionimg"
                    alt=" Children's Convent School Rajkot"
                  />
                </LazyLoad>
              </a>
              <p>
                For more details: Read the guideline attached in Latest News/
                Highlights section.
              </p>
            </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default StudentInfo;
